export default "<json-schema-datetime-control control=\"$ctrl.control\"></json-schema-datetime-control>\r\n";